import { __assign } from "tslib";
import pino from 'pino';
import whereami from './whereami';
export var availableLogLevels = [
    'trace',
    'debug',
    'info',
    'warn',
    'error',
    'fatal',
];
export var consoleLogger = function (options) {
    if (options === void 0) { options = {}; }
    var level = options.level;
    var logLevel = whereami.isClientSide
        ? level || 'error'
        : level || process.env['LOG_LEVEL'] || 'error';
    var levelIndex = availableLogLevels.indexOf(logLevel);
    return availableLogLevels.reduce(function (methods, level, index) {
        var _a;
        return __assign(__assign({}, methods), (_a = {}, _a[level] = index >= levelIndex ? customConsole[level] : customConsole.silent, _a));
    }, {});
};
// console with same pino methods
export var customConsole = __assign(__assign({}, Object.entries(console).reduce(function (acc, _a) {
    var _b;
    var key = _a[0], value = _a[1];
    if (availableLogLevels.includes(key)) {
        return __assign(__assign({}, acc), (_b = {}, _b[key] = value, _b));
    }
    return acc;
}, {})), { fatal: console.error, silent: function () { return undefined; } });
export var serverLogger = function (config) {
    if (config === void 0) { config = {}; }
    var level = config.level, name = config.name;
    return pino({
        browser: {
            disabled: true,
        },
        level: level || process.env['LOG_LEVEL'] || 'error',
        name: name,
    });
};
var Logger = function (config) {
    var isProductionEnv = process.env['NODE_ENV'] === 'production';
    if (whereami.isClientSide || !isProductionEnv)
        return consoleLogger(config);
    return serverLogger(config);
};
export default Logger;
//# sourceMappingURL=logger.js.map